require('./insuranceRequestWizardStep3PlanModal.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { formatText } = require('core/i18n').i18n;

// @ commonsComponents
const { ModalCustom } = require('commonsComponents/modalCustom');
const { OKButton } = require('components/commons/OKButton/OKButton');


const InsuranceRequestWizardStep3PlanModal = props => {
    const {
        handleRequestClose,
        isOpen,
        loading,
        onRequestAccept,
    } = props;

    return (
        <ModalCustom
            extraClass="insurance-request-wizard-basic-plan-modal"
            isOpen={isOpen}
            onRequestClose={handleRequestClose}
        >
            <section className="insurance-request-wizard-basic-plan-modal__section">
                <div className="insurance-request-wizard-basic-plan-modal__title-section">
                    <div className="insurance-request-wizard-basic-plan-modal__title">
                        {formatText('insuranceRequestHome-insuranceRequestHome_step3basicPlanValidationTitle')}
                    </div>
                    <div className="insurance-request-wizard-basic-plan-modal__subtitle">
                        {formatText('insuranceRequestHome-insuranceRequestHome_step3basicPlanValidationSubtitle')}
                    </div>
                </div>
                <div className="insurance-request-wizard-basic-plan-modal__separator"></div>
                <div className="insurance-request-wizard-basic-plan-modal__buttons">
                    <div className="insurance-request-wizard-basic-plan-modal__button-left">
                        <OKButton
                            modifier="link-ghost"
                            onClick={handleRequestClose}
                        >
                            {formatText('insuranceRequestHome-insuranceRequestHome_step3basicPlanValidationCancel')}
                        </OKButton>
                    </div>
                    <div className="insurance-request-wizard-basic-plan-modal__button-right">
                        <OKButton
                            id="btnRncPamentModalNext"
                            loading={loading}
                            modifier="primary"
                            onClick={onRequestAccept}
                            size="regular"
                        >
                            {formatText('insuranceRequestHome-insuranceRequestHome_step3basicPlanValidationAccept')}
                        </OKButton>
                    </div>
                </div>
            </section>
        </ModalCustom>
    );
};

InsuranceRequestWizardStep3PlanModal.propTypes = {
    handleRequestClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    onRequestAccept: PropTypes.func.isRequired,
};

module.exports = InsuranceRequestWizardStep3PlanModal;